// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/braze_report_dashboard_run_event/:dashboard_type(/:dashboard_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementBrazeReportDashboardRunEvent } from "./constants";
import type { ReportDashboardRunEventResult } from "./types";

export const getReportDashboardRunEvent = reactQueryFetcherAdapter(
  engagementBrazeReportDashboardRunEvent,
  (
    signal: AbortSignal,
    appGroupId: string,
    dashboardType: string,
    dashboardId?: string
  ): Promise<ReportDashboardRunEventResult> => {
    const url = dashboardId
      ? `/engagement/braze_report_dashboard_run_event/${dashboardType}/${dashboardId}`
      : `/engagement/braze_report_dashboard_run_event/${dashboardType}`;

    return fetch(url, "GET", { app_group_id: appGroupId }, { signal });
  }
);
